<template>
  <footer class="footer">
    <div class="container">
      <!-- Contact Info -->
      <div class="footer-section contact-info">
        <h4>Contact Us</h4>
        <ul>
          <li>
            Email:
            <a
              href="mailto:info@al-furqanacademy.com?subject=Inquiry%20about%20services"
              >info@al-furqanacademy.com</a
            >
          </li>
          <li>Phone: <a href="tel:+201091238424">+201091238424</a></li>
          <li>
            Address:
            <span>Dakahlia, Mansoura, Egypt</span>
          </li>
          <li class="free-trial-btn">
            <router-link @click="scrollTop" to="/contact-us"
              >Book A Free Lesson Now</router-link
            >
          </li>
        </ul>
      </div>

      <!-- Quick Links -->
      <div class="footer-section quick-links">
        <h4>Quick Links</h4>
        <ul>
          <li><router-link @click="scrollTop" to="/">Home</router-link></li>
          <li>
            <router-link @click="scrollTop" to="/about">About Us</router-link>
          </li>
          <li>
            <router-link @click="scrollTop" to="/plans">Plans</router-link>
          </li>
          <li>
            <router-link @click="scrollTop" to="/contact-us"
              >Contact Us</router-link
            >
          </li>
          <li>
            <router-link to="/terms_and_conditions"
              >Terms & Conditions</router-link
            >
          </li>
          <li>
            <router-link to="/privacy_policy">Privacy Policy</router-link>
          </li>
        </ul>
      </div>

      <!-- Social Media -->
      <div class="footer-section social-media">
        <h4>Follow Us</h4>
        <ul>
          <li>
            <a
              href="https://www.facebook.com/profile.php?id=61578066607647"
              target="_blank"
            >
              <font-awesome-icon :icon="['fab', 'facebook-f']" /> Facebook
            </a>
          </li>
          <li>
            <a
              href="https://www.tiktok.com/@furqanacademy101?_t=ZS-8xE1tXqCpPd&_r=1"
              target="_blank"
            >
              <font-awesome-icon :icon="['fab', 'tiktok']" /> TikTok
            </a>
          </li>
          <li>
            <a
              href="https://www.youtube.com/@alfurqanacademy-k6t"
              target="_blank"
            >
              <font-awesome-icon :icon="['fab', 'youtube']" /> YouTube
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div class="footer-bottom">
      <p>© 2026 <strong>Al-Furqan Academy</strong>. All rights reserved.</p>
    </div>
  </footer>
</template>
<script>
export default {
  methods: {
    scrollTop() {
      window.scrollTo({ top: 0 });
    },
  },
};
</script>
<style lang="scss" scoped>
/* General Styles */
.footer {
  background-color: #1a1a1a;
  color: #f1f1f1;
  padding: 3em 1.5em 1.5em;
  font-size: 0.95rem;

  .container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 2em;
    max-width: 1200px;
    margin: 0 auto;
  }

  .footer-section {
    h4 {
      font-size: 1.2em;
      margin-bottom: 0.8em;
      color: var(--primary);
      text-transform: uppercase;
    }

    ul {
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        margin-bottom: 0.8em;
        line-height: 1.5;
        font-size: 0.95em;

        a {
          color: #ddd; // a lighter color to stand out against the dark background
          text-decoration: none;
          transition: color 0.3s ease;

          &:hover {
            color: var(--primary);
            text-decoration: underline;
          }
        }
      }
    }
  }

  /* ✅ Free Trial Button */
  .free-trial-btn a {
    display: inline-block;
    background-color: var(--primary);
    color: #fff;
    padding: 0.6em 1.2em;
    border-radius: 6px;
    font-weight: 500;
    font-size: 1em;
    transition: background-color 0.3s ease;

    &:hover {
      background-color: var(--hover-button);
    }
  }

  /* ✅ Social Media */
  .social-media {
    ul {
      display: flex;
      flex-direction: column;
      gap: 0.8em;

      a {
        display: flex;
        align-items: center;
        gap: 10px;
        font-weight: 500;
        color: #ddd;

        &:hover {
          color: var(--primary);
        }

        svg {
          font-size: 1.2em;
          color: var(--primary);
        }
      }
    }
  }

  /* ✅ Footer Bottom */
  .footer-bottom {
    text-align: center;
    margin-top: 2em;
    padding-top: 1em;
    border-top: 1px solid #333;
    font-size: 0.85em;
    color: #bbb;
  }
}
</style>
